// extracted by mini-css-extract-plugin
export default {"border-container":"1px solid rgb(221, 224, 230)","section":"styles_section__Vtts9","policyAccountCol":"styles_policyAccountCol__YoSEE"};